import omit from "lodash/omit";

import {
  ADD_USER_FAILED,
  ADD_USER_START,
  ADD_USER_SUCCESS,
  REMOVE_GROUP_SUCCESS,
  REMOVE_USER_FAILED,
  REMOVE_USER_START,
  REMOVE_USER_SUCCESS,
  SET_CURRENT_USER,
  SET_USERS_GROUPS_FILTER_TERM} from "../constants";

const usersMainReducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        current: action.uri
      };
    case SET_USERS_GROUPS_FILTER_TERM:
      return {
        ...state,
        filterTerm: action.filterTerm
      };
    case ADD_USER_START:
      return {
        ...state,
        saving: true
      };
    case ADD_USER_SUCCESS:
      return omit(
        {
          ...state,
          saving: false
        },
        ["errorDescription", "error"]
      );
    case ADD_USER_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    case REMOVE_USER_START:
      return {
        ...state,
        saving: true
      };
    case REMOVE_USER_SUCCESS:
      return omit(
        {
          ...state,
          saving: false,
          items: state.items.filter(user => user.$uri !== action.user.$uri)
        },
        ["errorDescription", "error", "current"]
      );
    case REMOVE_USER_FAILED:
      return {
        ...state,
        errorDescription: action.error.description,
        error: action.error.message,
        saving: false
      };
    case REMOVE_GROUP_SUCCESS:
      return {
        ...state,
        items: state.items.map(user => {
          const thisUser = { ...user };
          if (thisUser.groups) {
            thisUser.groups = thisUser.groups.filter(
              group => group.$ref !== action.group.$uri
            );
          }
          return thisUser;
        })
      };
    default:
      return state;
  }
};

export default usersMainReducer;
